import NavBarContainer from 'components/NavBar/NavBarContainer'
import NavBarPresentation from 'components/NavBar/NavBarPresentation'
import NavBarData from 'components/NavBar/NavBarData'

export default {
  Container: NavBarContainer,
  Presentation: NavBarPresentation,
  Data: NavBarData,
}
